<template>
  <div>
    <TopoComponent></TopoComponent>
    <div class="divFalha">
       <img class="imgFalha mt-3" src="/assets/img/atencao.svg" alt="">
       <p class="espaco"></p>
       <p class="mensagemFalha">Você já está em processo de validação pela nossa equipe e em até 24H finalizaremos a validação.</p>
       <p class="espaco"></p>
       <p class="mensagemFalha">Em caso de dúvidas ou problemas entre em contato agora mesmo. <a href="/suporte">Clique aqui.</a></p>
       <div class="clearfix"></div>
    </div>
  </div>   
</template>

<script>
import TopoComponent from '@/components/TopoComponent'
import OctadeskComponent from '@/components/OctadeskComponent'

export default {
  name: 'cadastro',
  components: { TopoComponent, OctadeskComponent },
  data() {
    return {
        userToken : sessionStorage.getItem("token")
    }
  }
}
</script>


<style  scoped>
.imgFalha{
  max-width: 550px;
  text-align: center;
}
.divFalha{
  text-align: center;
}
.mensagemFalha{
   color: gray;
   text-align: center;
   font-size: 20px;
}
.espaco{
  margin: 50px;
}
</style>